export const IconTimer = ({ style, className }) => {
  return (
    <svg
      style={style}
      className={className}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path opacity="0.4" d="M24.0002 44.0001C33.5768 44.0001 41.3402 36.2367 41.3402 26.6601C41.3402 17.0835 33.5768 9.32007 24.0002 9.32007C14.4235 9.32007 6.66016 17.0835 6.66016 26.6601C6.66016 36.2367 14.4235 44.0001 24.0002 44.0001Z"/>
      <path d="M24 27.5C23.18 27.5 22.5 26.82 22.5 26V16C22.5 15.18 23.18 14.5 24 14.5C24.82 14.5 25.5 15.18 25.5 16V26C25.5 26.82 24.82 27.5 24 27.5Z"/>
      <path d="M29.7812 6.9H18.2212C17.4212 6.9 16.7812 6.26 16.7812 5.46C16.7812 4.66 17.4212 4 18.2212 4H29.7812C30.5813 4 31.2212 4.64 31.2212 5.44C31.2212 6.24 30.5813 6.9 29.7812 6.9Z"/>
    </svg>
  );
};